import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import { netlifyDebug, localDebug, isWebinar , getUrlVars , isFVlite, checkDomainExpire, checkRoomExists} from '../../lib/lib'
import config from '../../config/config';
import images from '../../config/images';
import randToken from 'rand-token';

// const loginButton =  {
//   borderRadius: "6px", 
//   border: "#333 solid 2px", 
//   backgroundColor: "#ffffff",
//   padding: "0.5em", 
//   fontSize: "20",
//   fontWeight: 700,
//   paddingRight: "6px",
//   right: "20px",
//   top: "20px",
//   position: "absolute"
// }
const timerDownloadApp = 3500

class SeminarMode extends Component {
  constructor(props) {
    super(props)
    this.state = {
      iOS: true
    }
  }
  handleClick = async() =>{
    if(this.state.iOS){
      if(isWebinar()){
        window.location = `fvwebinar://open.fvwebinar${window.location.pathname+window.location.search}`
        // setTimeout(() => {
        //   window.location = "https://itunes.apple.com/jp/app/freshvoice-webinar/id1325343868"
        // }, timerDownloadApp)
      }else if(isFVlite()){
        window.location = `fvlite://${window.location.host}${window.location.pathname}`
        // setTimeout(() => {
        //   window.location = "https://itunes.apple.com/jp/app/freshvoice-lite/id1463312007"
        // }, timerDownloadApp)
      }else{
        window.location = `sessionsdd://open.sessions${window.location.pathname}`
        // setTimeout(() => {
        //   window.location = "https://itunes.apple.com/jp/app/dd/id1435000009?mt=8"
        // }, timerDownloadApp)
      }
    }else{
      if(isWebinar()){
        window.location = `fvwebinar://open.fvwebinar/${(window.location.pathname+window.location.search).substr(1)}`
        // setTimeout(() => {
        //   window.location = "https://play.google.com/store/apps/details?id=com.fvwebinar"
        // }, timerDownloadApp)  
      }else if(isFVlite()){
        window.location = `fvlite://${window.location.host}${window.location.pathname}`
        // setTimeout(() => {
        //   window.location = "https://play.google.com/store/apps/details?id=com.fvlite"
        // }, timerDownloadApp)
      }else{
        window.location = `sessionsdd://sessionsdd/${window.location.pathname}`
        // setTimeout(() => {
        //   window.location = "https://play.google.com/store/apps/details?id=com.sessions_mobile"
        // }, 2000) 
      }
    }
  }

  handleDownload = async() =>{
    if(this.state.iOS){
      if(isWebinar()){
        window.location = "https://itunes.apple.com/jp/app/freshvoice-webinar/id1325343868"
      }else if(isFVlite()){
        window.location = "https://itunes.apple.com/jp/app/freshvoice-lite/id1463312007"
      }else{
        window.location = "https://itunes.apple.com/jp/app/dd/id1435000009?mt=8"
      }
    }else{
      if(isWebinar()){
        window.location = "https://play.google.com/store/apps/details?id=com.fvwebinar"
      }else if(isFVlite()){
        window.location = "https://play.google.com/store/apps/details?id=com.fvlite"
      }else{
        window.location = "https://play.google.com/store/apps/details?id=com.sessions_mobile"
      }
    }
  }

  async componentDidMount (){
    if(window.location.pathname === "/" && ( localDebug() || window.location.hostname === "localhost" )){
      window.location = "/" + randToken.generate(2);
    }
    if(!isWebinar()){
      this.roomName = this.props.api.location.pathname.replace(/\//g,'')
    } 
    if(isFVlite()){
      if (window.location.hostname !== "localhost" && !localDebug() && !netlifyDebug() ){
        const domain_check = await checkDomainExpire();
        const room_check = await checkRoomExists(this.roomName)
        if(domain_check.errors) {
          alert("ドメインが見つかりません")
          if(config.API_HOST === "workshop.tokyo"){
            window.location = "https://admin.lfv.jp/"
          }else{
            window.location = "https://admin-dev.lfv.jp/"
          }
          return
        }    
        if(domain_check.data && domain_check.data.expire){
          alert("ドメインは期限切れです")
          if(config.API_HOST === "workshop.tokyo"){
            window.location = "https://admin.lfv.jp/"
          }else{
            window.location = "https://admin-dev.lfv.jp/"
          }
          return
        }
        if(!room_check.data){
          alert("部屋は存在しません")
          if(config.API_HOST === "workshop.tokyo"){
            window.location = "https://admin.lfv.jp/"
          }else{
            window.location = "https://admin-dev.lfv.jp/"
          }
          return
        }
      }
    }
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.setState({iOS})
    if(window.location.pathname === "/"){
      if(isWebinar()){
        if(config.API_HOST === "workshop.tokyo"){
          window.location.href = "/webinar/?token=" + config.WEBINAR_PROD_TEST2_DEBUG_TOKEN
        }else{
          window.location.href = "/webinar/?token=" + config.WEBINAR_DEV_TEST2_DEBUG_TOKEN
        } 
      }else{
        window.location.href = '/test'
      }
    }
  }

  render(){
    return(
        <div css={{overflow: "hidden"}}>
          {!isWebinar() &&
          <h3 style={{textAlign:"center",position: "relative",top: "25px"}}>{this.roomName}</h3>
          }
          <img src={  isFVlite() ? images.logo : ( isWebinar() ? images.webinar_logo : images.dd_logo_rec) } alt="logo" style={{
            width: "50vw",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            alignItems: "center",
            marginTop: "15vw",
            backgroundColor: isWebinar() ? "#0084ff" : null
             }} />
          <FlatButton onClick={this.handleClick} style={styles.button}>
            アプリで開く
          </FlatButton>
          <FlatButton onClick={this.handleDownload} style={styles.button}>
            アプリをダウンロードする
          </FlatButton>  
          { !isWebinar() && <div>
            <FlatButton  onClick={() => {
                if(isWebinar()){
                  const query = getUrlVars()
                  window.location.assign(`${window.location.pathname}?mobile=true&token=${query.token}`);
                }else{
                  window.location.assign(`${window.location.pathname}?mobile=true`);
                }
              }} style={styles.button}>
              { this.state.iOS ?  "すぐに開く(α版)" : "Chromeで開く(α版)"}
            </FlatButton>
            <div style={styles.text}>
              { this.state.iOS ? (<div> 
                <p>Safariから開いてください</p>
                <p>(アプリ内ブラウザからは起動できません)</p>
                </div> ): null}
            </div>  
            </div>  }
        </div>
    )
  }

}

const styles = {
  button: {
    width: "50vw",
    height: "10vw",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    alignItems: "center",
    marginTop: "15vw",
    backgroundColor: "#eee"
  },
  text: {
    width: "50vw",
    height: "10vw",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    alignItems: "center",
    marginTop: "1vw",
  }
  
}

export default SeminarMode;



// WEBPACK FOOTER //
// ./src/routes/PrepareSession/mobile.js